import(/* webpackMode: "eager" */ "/app/src/components/pages/EventPage/Goty2024/index.jsx")